import React, { useState, useEffect } from 'react'
import { Button, Layer, NoData } from 'components'
import useApp from 'hooks/useApp'
import Native from 'library/native'
import CertImportLayer from 'views/setting/cert/CertImportLayer'
import { useRecoilState } from 'recoil'
import { showCertImportLayerState } from 'views/setting/cert/states'
import Lib from 'library'

const CertiManageLayer = (props) => {

	const App = useApp()

	const [showCertImportLayer, setShowCertImportLayer] = useRecoilState(showCertImportLayerState)
	const [certList, setCertList] = useState()

	const onDelete = (subjectDn) => {
		Native.vibrate("heavy")
		App.alert({
			msg: "삭제시 해당 공동인증서로 연결된 기관은 연결해제되며 더 이상 새로운 데이터를 업데이트 할 수 없습니다. 그래도 진행하시겠습니까?",
			sub: "기존 데이터는 유지됩니다.",
			confirm: true,
			type: "bottom",
			onOk: () => {
				Native.execute("Cert", "removeCert", (result) => {
					const json = JSON.parse(result)
					if (json.resultCode === "0") {
						App.alert("삭제되었습니다.")
						getCertList()
					} else {
						App.alert(`오류가 발생했습니다. (code: ${json.resultCode})`)
					}
				},
					{ subjectDn: subjectDn }
				)
			}
		})
	}


	const getCertList = () => {
		Native.execute("Cert", "certList", function (result) {
			const resultData = JSON.parse(result)
			if(resultData.resultCode === "0"){
				const data = JSON.parse(result).result
				setCertList(data)
			}else{
				setCertList([])
				App.alert(`인증서를 가져오지 못하였습니다.`)
			}
		}, {})
	}

	useEffect(() => {
		if (showCertImportLayer === false && props.show === true) getCertList()
	}, [props.show, showCertImportLayer])

	return (
		<Layer {...props}>
			<div className="page">
				<div className="flex_1 padding">
					<div style={{ fontSize: "2rem", fontWeight: 500 }}>인증서 관리</div>
					<ul className="document-select mt_40">
						{
							certList &&
								certList.length > 0 ? certList.map((item, index) => {
									const date = Lib.ChanageNewDate(item.expiredDate.replace(/-/g, "/"))
									const today = new Date()
									let cc
									if (today > date) {
										cc = "over"
									} else if (today.getTime() + (1000 * 60 * 60 * 24 * 30) > date.getTime()) {
										cc = "warn"
									}

									const remain = Math.ceil((date - today) / 1000 / 60 / 60 / 24)

									return (
										<li key={index} className={cc === "over" ? cc : undefined}>
											<i className={`icon icon_document${cc ? ` ${cc}` : ""}`} />
											<div className="ml_20">
												<p>{item.userName.replace(/\(\)/, "")}</p>
												<ul className="mt_10">
													<li>
														<span>발급자</span>
														<span>{item.auth}</span>
													</li>
													<li>
														<span>용도</span>
														<span>{item.usage}</span>
													</li>
													<li>
														<span>만료일</span>
														<span className="nowrap">{item.expiredDate}{cc !== "over" && <i className="tag tag-round tag-red ml_5">D-{remain}</i>}</span>
													</li>
												</ul>
											</div>
											<div className="del_btn" onClick={() => onDelete(item.subjectDn)}>삭제</div>
										</li>
									)
								})
								:
								<NoData text="등록된 인증서가 없습니다." sub="하단의 인증서가져오기 버튼을 클릭하시거나 인증센터 > 인증서 가져오기 메뉴를 클릭하여 인증서를 복사 후 이용하실 수 있습니다." />
						}
					</ul>
				</div>
				<div className="flex-shrink_0 padding">
					<Button className="btn btn--big" onClick={() => setShowCertImportLayer(true)}>인증서 가져오기</Button>
				</div>
			</div>

			<CertImportLayer />

		</Layer>
	)
}

export default CertiManageLayer